import ToggleElementsViaRadioButtons from "../../../../toggle_elements_via_radio_buttons";

let recipientElementToggler = null;

const attach = () => {
  if (!recipientElementToggler) {
    recipientElementToggler = new ToggleElementsViaRadioButtons(
      "#recipient_target_fields",
      {
        some: "#patron_catagory_fields",
      }
    );
  }

  recipientElementToggler.attach();
};

const detach = () => {
  if (recipientElementToggler) {
    recipientElementToggler.detach();
  }

  recipientElementToggler = null;
};

$(attach);
document.addEventListener("turbolinks:load", attach);
document.addEventListener("turbolinks:before-cache", detach);
document.addEventListener("turbolinks:before-render", detach);
